export default "__VITE_ASSET__8505bcd2__"